import { render, staticRenderFns } from "./update-wallet-settings.vue?vue&type=template&id=37f88883&scoped=true"
import script from "./update-wallet-settings.vue?vue&type=script&lang=js"
export * from "./update-wallet-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f88883",
  null
  
)

export default component.exports